module.exports = __webpack_public_path__ + "assets/tb-db-icon-add-return-center.svg";